import {APP_INITIALIZER, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LayoutComponent} from './layout.component';
import {ButtonModule} from 'primeng/button';
import {RippleModule} from 'primeng/ripple';
import {MenuBarComponent} from './menu-bar/menu-bar.component';
import {RouterModule} from '@angular/router';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {LayoutPopUpComponent} from './pop-up/layout-pop-up.component';
import {TaskComponent} from './task/task.component';
import {DialogModule} from 'primeng/dialog';
import {TableModule} from 'primeng/table';
import {ComponentsModule} from '../components/components.module';
import {HasAnyAuthorityMenuDirective} from './has-any-authority-menu.directive';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {TranslateModule} from '@ngx-translate/core';
@NgModule({
    declarations: [LayoutComponent, LayoutPopUpComponent, MenuBarComponent, TaskComponent, HasAnyAuthorityMenuDirective],
    imports: [CommonModule, ComponentsModule, RouterModule, ButtonModule, RippleModule, TieredMenuModule, DialogModule,
        TableModule, ScrollPanelModule,
        TranslateModule],
    exports: [LayoutComponent]
})
export class LayoutModule {
}
